module.exports = __webpack_public_path__ + "static/img/4P3_button.ba69c103.png";